module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyMSIgaGVpZ2h0PSIyMSIgdmlld0JveD0iMCAwIDIxIDIxIj4KICAgIDxwYXRoIGZpbGw9IiNGRkYiIGZpbGwtcnVsZT0iZXZlbm9kZCIgZD0iTTQgMjFoMnYtNkgwdjJoNHY0ek02IDBINHY0SDB2Mmg2VjB6bTkgNmg2VjRoLTRWMGgtMnY2em0yIDExaDR2LTJoLTZ2Nmgydi00eiIvPgo8L3N2Zz4K"


//////////////////
// WEBPACK FOOTER
// ./~/video-player/dist/src/assets/full-screen/exit-full-screen.svg
// module id = 1682
// module chunks = 1 2 3